import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react';

export default function CallForwarding() {
  const navigate = useNavigate();
  const { getToken, isSignedIn, isLoaded } = useAuth();

  return (
    <div>
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">Call Forwarding</h1>
        <p className="text-gray-600 dark:text-gray-400 dark:text-gray-300 dark:text-gray-600">Learn how to forward calls to your ParrotMate numbers</p>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-200 dark:border-gray-700 shadow-sm">
        <div className="prose prose-gray dark:prose-invert max-w-none">
          <p className="text-gray-700 dark:text-gray-300 dark:text-gray-600">
            To forward your calls to your ParrotMate numbers, you'll need to set up
            "No Answer/Busy Transfer" with your current phone provider. This feature
            is often called "Conditional Call Forwarding."
          </p>
          
          {/* Multiple Numbers Information */}
          <div className="my-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg">
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0">
                <svg className="w-5 h-5 text-blue-600 dark:text-blue-400 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div>
                <h3 className="text-sm font-medium text-blue-800 dark:text-blue-200 mb-2">
                  Multiple ParrotMate Numbers
                </h3>
                <p className="text-sm text-blue-700 dark:text-blue-300">
                  If you have multiple ParrotMate numbers assigned to the same Parrot, you can choose any of them for call forwarding. All numbers will reach the same AI agent, so pick the one that's most convenient for your callers (e.g., local area code).
                </p>
              </div>
            </div>
          </div>
          
          <p className="text-gray-700 dark:text-gray-300 dark:text-gray-600">
            Here are the general steps. The exact process may vary depending on your provider.
          </p>
          <ol className="text-gray-700 dark:text-gray-300 space-y-3 dark:text-gray-600">
            <li>
              <strong className="text-gray-900 dark:text-white">Contact your phone provider:</strong> Call your current mobile or landline
              provider's customer service.
            </li>
            <li>
              <strong className="text-gray-900 dark:text-white">Request "No Answer/Busy Transfer":</strong> Ask them to enable this feature
              on your line.
            </li>
            <li>
              <strong className="text-gray-900 dark:text-white">Provide your ParrotMate number:</strong> They will ask for the phone number
              to which the calls should be forwarded. Provide them with any of the numbers you
              purchased through ParrotMate that are assigned to your desired Parrot.
            </li>
          </ol>
          <p className="text-gray-700 dark:text-gray-300 dark:text-gray-600">
            Once this is set up, any calls you don't answer or that come in while you're busy
            will be automatically forwarded to your ParrotMate parrot.
          </p>
        </div>
      </div>
    </div>
  );
}
